// Create link components for planning guide, survey, story, research panel

import { SimplifiedUserRole } from '@platform/client/schemas';
import FlexibleLink from '../../util/FlexibleLink';

// should handle: active and url can be undefined or null, only required is text

export const DISCOVERY_GUIDE_URL =
  'https://movingworldspublic.blob.core.windows.net/public/discovery-call-guide.pdf';
const PRO_USER_RESEARCH_PANEL_URL = 'https://airtable.com/app52Jr9tGasvgDRB/pagBDDdR2lbqHgCsU/form';
const ORG_USER_RESEARCH_PANEL_URL = 'https://airtable.com/app52Jr9tGasvgDRB/pagpldjz3UtzCCTPH/form';

export const HubExternalLink = ({
  children,
  url,
  active = true,
}: {
  children: string;
  url?: string | null;
  active?: boolean;
}) => {
  return url && active ?
      <FlexibleLink type='external' newTab={true} className='blue-link' href={url}>
        {children}
      </FlexibleLink>
    : <span>{children}</span>;
};

export const ResearchPanelLink = ({
  userType,
  children,
  active = true,
}: {
  userType: SimplifiedUserRole;
  children: string;
  active?: boolean;
}) => {
  const url =
    userType === SimplifiedUserRole.PROFESSIONAL ?
      PRO_USER_RESEARCH_PANEL_URL
    : ORG_USER_RESEARCH_PANEL_URL;
  return (
    <HubExternalLink url={url} active={active}>
      {children}
    </HubExternalLink>
  );
};
